"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const novoDark_1 = __importDefault(require("./novoDark"));
const novoColorPalette_1 = __importDefault(require("./novoColorPalette"));
// based on current docs, dark theme remains the same as "novo"
const neoDark = {
    ...novoDark_1.default,
    brand01: novoColorPalette_1.default.white,
};
exports.default = neoDark;
